import React, { useState } from "react";
import SEO from "../components/Seo";
import "@styles/index.scss";
import Navbar from "@organism/Navbar/Navbar";
import Footer from "@organism/Footer/Footer";
import ScrollTopButton from "@molecules/ScrollTopButton";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { isBrowser } from "@utils/isBrowser";
import FloatingSeeDemo from "../components/molecules/FloatingSeeDemo";
import Hero from "@organism/Hero/Hero";
import PipeDriveChat from "@utils/pipedriveChat";
// Imports directos (antes loadable()): Gatsby ya code-splittea por página y el
// plugin de SSR para loadable está deshabilitado, así que estas secciones no se
// renderizaban en el HTML y aparecían en cliente empujando el footer (CLS 0.52).
import N5Impact from "@organism/N5Impact/N5Impact";
import Testimonies from "@organism/Testimonies/Testimonies";
import Partners from "@organism/Partners/Partners";
import Awards from "@organism/Awards/Awards";
import BgLayout from "@atoms/BgLayout";
import Brands from "@molecules/Brands";
import FinancialIndustry from "@organism/FinancialIndustry/FinancialIndustry";
import CapabilitiesTags from "@molecules/CapabilitiesTags";

const IndexPage = ({ location }) => {
  const { t } = useTranslation();
  const { language } = useI18next();

  const [chatStyle, setChatStyle] = useState(`
          html body #LeadboosterContainer.proactiveChat, html body #LeadboosterContainer
          {
            bottom: -1rem!important;
            right: -1rem!important;
          }
          
          #LeadboosterContainer button[data-testid="chat-bubble"]{
            border-radius: 100%!important;
            transform: scale(0.65)!important;
          }
  `);
  const [clientChat, setClientChat] = useState(false);
  const [initChat, setinitChat] = useState(false);
  const [configChat, setConfigChat] = useState(false);

  const handleOnLoad = () => {
    if (isBrowser) {
      if (window.screen.width > 800) {
        setTimeout(() => {
          setChatStyle(`
          #LeadboosterContainer.proactiveChat, #LeadboosterContainer
          {
            bottom: -1rem!important;
            right: -1rem!important;
          }

          #LeadboosterContainer button[data-testid="chat-bubble"]{
            border-radius: 100%!important;
            transform: scale(0.65)!important;
          }
          `);
        }, 2500);
      }
    }
  };
  const openChat = () => {
    window.location.reload();
    setinitChat(true);

    let configChatScript = "";
    if(language === "es"){
      configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: 'aa14fb85-5636-4d61-b888-0a30680a8223',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
    }
    else if (language === "en") {
      configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: '07f65e6b-8ff1-4d07-9936-999270c3ba36',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
    }
    else {
      configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: '6a3c384d-b125-4bc3-b0ab-8b95389194e5',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
    }

    const pipedriveScript =
      "https://leadbooster-chat.pipedrive.com/assets/loader.js";

    setConfigChat(configChatScript);
    setClientChat(pipedriveScript);

    handleOnLoad();
  };

  return (
    <>
      <SEO
        title={t("SEO.HOME.TITLE")}
        description={t("SEO.HOME.DESCRIPTION")}
        originUrl={location.origin}
        siteUrl={location.href}
        lang={language}
      />
      <Navbar location={location} />
      <Hero openChat={openChat} />
      <N5Impact />
      <FinancialIndustry language={language} openChat={openChat} />
      <Partners />
      <BgLayout>
        <Awards />
        <Testimonies home location={location} />
      </BgLayout>
      <Brands showTitle gradients isHome />
      <CapabilitiesTags />
      <PipeDriveChat />
      <FloatingSeeDemo />
      <ScrollTopButton />
      <Footer openChat={openChat} />
    </>
  );
};

export default IndexPage;
